module.exports = __webpack_public_path__ + "static/media/transilluminator-open.92584231.svg";